import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  AddCustomerResponse,
  CustomerCommonResponse,
  Customer,
  CustomerResponse,
  CustomerType,
  AddCustomerTypeResponse,
  Type,
} from '@core/interface/customer';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private http: HttpClient) {}

  getCustomers(data?: PagePayload) {
    const filter = { ...data };
    if (typeof filter?.customer_type !== 'undefined') {
      filter.type = filter.customer_type;
    }
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<CustomerResponse>(environment.endPoints.customerList, {
      params: httpParams,
    });
  }
  addCustomer(data: Customer) {
    return this.http.post<AddCustomerResponse>(
      environment.endPoints.customerAddEdit,
      data
    );
  }
  deleteCustomer(id: number) {
    return this.http.get<CustomerCommonResponse>(
      environment.endPoints.customerDelete(id)
    );
  }

  getCustomerType() {
    return this.http.get<CustomerType>(environment.endPoints.customerType);
  }
  addCustomerType(data: Type) {
    return this.http.post<AddCustomerTypeResponse>(
      environment.endPoints.customerAddTypeEdit,
      data
    );
  }
  deleteCustomerType(id: number) {
    return this.http.get<CustomerCommonResponse>(
      environment.endPoints.customerTypeDelete(id)
    );
  }
}
